import { QRCodeCanvas } from "qrcode.react";
import { Printer } from "lucide-react";

export const BikeQR = ({ bike }) => {
  const url = `${window.location.origin}/fleet/bikes/${bike.id}`;
  const print = () => {
    const canvas = document.getElementById(`qr-${bike.id}`);
    const w = window.open("", "_blank");
    w.document.write(`<html><head><title>${bike.name} QR</title></head><body style="font-family:sans-serif;text-align:center;padding:40px">
      <img src="${window.location.origin}/brand/logo.png" width="70"/><h2 style="margin:8px 0">${bike.name}</h2><p>${bike.registration || ""}</p>
      <img src="${canvas.toDataURL("image/png")}" width="260"/><p style="font-size:13px">Scan for bike checks &amp; records</p>
      <script>window.onload=()=>window.print()</script></body></html>`);
    w.document.close();
  };
  return (
    <div className="flex flex-col items-center gap-3 rounded-2xl border bg-card p-5" data-testid="bike-qr">
      <div className="rounded-xl bg-white p-3"><QRCodeCanvas id={`qr-${bike.id}`} value={url} size={168} level="M" /></div>
      <p className="text-center text-xs text-muted-foreground">Scan to open this bike and start a check</p>
      <button onClick={print} data-testid="bike-qr-print-btn" className="inline-flex items-center gap-2 rounded-full border px-4 py-2 text-xs font-semibold hover:bg-secondary"><Printer className="h-3.5 w-3.5" /> Print QR label</button>
    </div>
  );
};
